import { WorkflowActionTypeEnum } from 'constants/workflows';
import { uniq } from 'lodash';
import { WorkflowStep } from 'types/domain';

const filterMessageActionTypes = (steps: WorkflowStep[]) => {
    return steps.filter(
        step =>
            step.action === WorkflowActionTypeEnum.SEND_EMAIL ||
            step.action === WorkflowActionTypeEnum.SEND_SMS,
    );
};

const getMessageTypesFromSteps = (steps: WorkflowStep[]) => {
    const actionSteps = filterMessageActionTypes(steps);
    return uniq(actionSteps.map(step => step.action));
};

export { filterMessageActionTypes, getMessageTypesFromSteps };
